module.exports = __webpack_public_path__ + "static/media/error404desktop.158b0ef8.png";